import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

/**
 * Free-text input for loads.unidad that suggests matches from the Unidades catalog.
 * Never forces selection — the trucking company's real spreadsheet has all kinds of values.
 */
export function UnidadAutocomplete({ value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState([]);
  const boxRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  useEffect(() => {
    if (!open || !value) { setResults([]); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/unidades", { params: { search: value, activo: "true", limit: 6 } });
        setResults(data.items);
      } catch {
        /* silent */
      }
    }, 250);
    return () => clearTimeout(t);
  }, [value, open]);

  return (
    <div className="relative" ref={boxRef}>
      <Input
        value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        data-testid={testId}
      />
      {open && results.length > 0 && (
        <div className="absolute z-50 mt-1 w-full rounded-md border border-border bg-white shadow-lg">
          {results.map((r) => (
            <button
              key={r.id}
              type="button"
              onClick={() => { onChange(r.economico); setOpen(false); }}
              data-testid={`${testId}-option-${r.economico}`}
              className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-slate-50"
            >
              <span className="font-mono text-xs font-medium">{r.economico}</span>
              {r.placas && <span className="text-xs text-muted-foreground">{r.placas}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
